<template lang="pug">
#modal-visualizacao-laudo
    el-dialog(
        title='Fiscalização Operação',
        width='500px',
        :visible='show',
        @close='closeDialog()'
    )
        .mapa
            Mapa(
                :mapLayersConfigs='layersMaps',
                :mapConfig='mapConfig',
                :height='"100%"',
                :idMapa='"mapaVizualizacaoLaudo"',
                locked
            )

        p
            b Operação:
            |
            | {{ informacoesLaudo.identificadorOperacao }}
        p
            b Beneficiário:
            |
            | {{ informacoesLaudo.nomeBeneficiario }}
        p
            b Localidade dos territórios:
            |
            | {{ buscarNomeMunicipios() }}
        el-button(slot='footer', size='mini', @click='closeDialog()') Voltar
</template>

<script>
import Mapa from '@/components/MapaLeaflet.vue';
import OperacaoLaudoService from '@/services/OperacaoLaudoService';
import { getEstiloGeometria } from '@/utils/mapa/mapa.estilos';

export default {
    name: 'ModalVisualizacaoLaudo',

    components: {
        Mapa
    },

    props: {
        idLaudo: {
            type: Number | null,
            required: true
        },
        show: {
            type: Boolean,
            required: true
        }
    },

    data() {
        return {
            informacoesLaudo: {
                identificadorOperacao: '',
                nomeBeneficiario: '',
                territorios: ''
            },
            layersMaps: [],
            mapConfig: {
                controls: {}
            }
        };
    },

    watch: {
        idLaudo: function () {
            this.getInformacoes();
        }
    },

    mounted() {
        this.getInformacoes();
    },

    methods: {
        mostrarTerritorioNoMapa() {
            this.layersMaps = [];

            let layerTerritorio;
            this.informacoesLaudo.territorios.forEach(territorio => {
                layerTerritorio = {
                    style: getEstiloGeometria('area'),
                    name: 'Território Laudo',
                    geoJson: territorio.geometria
                };
                this.layersMaps.push(layerTerritorio);
            });
        },

        async getInformacoes() {
            if (!this.idLaudo) return null;

            await OperacaoLaudoService.buscarPorId(this.idLaudo)
                .then(({ data }) => {
                    this.informacoesLaudo = data;
                    setTimeout(() => this.mostrarTerritorioNoMapa(), 500);
                })
                .catch(() => {
                    this.$notify.error({
                        message:
                            'Não foi possível buscar as informações da fiscalização de operação'
                    });
                });
        },

        buscarNomeMunicipios() {
            let nomesDosMunicipios = this.informacoesLaudo.territorios
                .map(function (territorio) {
                    return territorio.nomeMunicipio;
                })
                .join(', ');
            return nomesDosMunicipios;
        },

        closeDialog() {
            this.$emit('update:show', false);
        }
    }
};
</script>

<style lang="scss">
#modal-visualizacao-laudo {
    .el-dialog__footer {
        margin-top: -30px;
        display: flex;
        justify-content: flex-start;
    }

    .mapa {
        height: 150px;
        border-radius: 4px;
        overflow: hidden;
        margin: -20px 0 20px 0;
    }

    .lista {
        margin-left: 15px;
    }

    .margin-p {
        margin-bottom: 0;
    }

    .margin-p-block {
        margin-top: 15px;
    }
}
</style>
